import React from 'react';

export default function Celebs({
	firstName,
	lastName,
	designation,
	image,
	color,
}) {
	return (
		<div className='subsquare'>
			<div className='img_wrapper' style={{ background: `url(${image})` }}></div>
			<div className='person-details'>
				<span className='name'>
					{firstName} {lastName}
				</span>
				<h5 className='designation'>{designation}</h5>
			</div>
		</div>
	);
}
